package com.example.event_management_system.data.repository

import com.example.event_management_system.data.models.Section
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class SectionRepository(
    private val firestore: FirebaseFirestore
) : ISectionRepository {

    private val sectionsCollection = firestore.collection("sections")

    override fun getSectionsByLocationFlow(locationId: String): Flow<List<Section>> {
        return sectionsCollection
            .where { "locationId" equalTo locationId }
            .snapshots
            .map { snapshot ->
                snapshot.documents
                    .map { doc -> doc.data<Section>().copy(id = doc.id) }
                    .filter { it.isActive }
                    .sortedBy { it.name }
            }
    }

    override suspend fun createSection(section: Section): String {
        val ref = sectionsCollection.document
        ref.set(section.copy(id = ref.id))
        return ref.id
    }

    override suspend fun updateSection(sectionId: String, section: Section) {
        sectionsCollection.document(sectionId).set(section.copy(id = sectionId))
    }

    override suspend fun deleteSection(sectionId: String) {
        sectionsCollection.document(sectionId).delete()
    }
}
